import React from "react"
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles"
// @material-ui/icons
// core components
import GridContainer from "../../../components/Grid/GridContainer.jsx"
import GridItem from "../../../components/Grid/GridItem.jsx"

import productStyle from "../../../assets/jss/material-kit-react/views/landingPageSections/productStyle.jsx"
import pickupImg from "../../../assets/img/pickup.jpg"
import deliveryImg from "../../../assets/img/delivery.jpg"
import orderAheadImg from "../../../assets/img/orderAgead.jpg"

class ProductImagesSection extends React.Component {
    render() {
        const { classes } = this.props
        return (
            <div>
                <div>
                    <div
                        className={classes.featuresSection}
                        style={{
                            backgroundColor: "rgb(247, 247, 247)",
                            borderBottom: "1px solid #ebebeb",
                        }}>
                        <GridContainer style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <GridItem xs={0} sm={0} md={0} lg={1} style={{ textAlign: "center" }} />
                            <GridItem xs={12} sm={12} md={3} lg={3} style={{ textAlign: "center", paddingBottom: "2rem" }}>
                                <div>
                                    <img src={pickupImg} alt="..." className={classes.productImage} />
                                </div>
                                <div
                                    className={classes.featureBoxTitle}
                                    style={{
                                        textAlign: "center",
                                        paddingTop: "1.5rem",
                                    }}>
                                    <span
                                        style={{
                                            fontWeight: "500",
                                            fontSize: "1.3rem",
                                        }}>
                                        {" "}
                                        Pick Up
                                    </span>
                                </div>
                                <div className={classes.productImagesDescription}>
                                    Enable your customers to browse your menu and order what they want for pick up.
                                    Maximize your business' throughput.
                                </div>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={3} lg={3} style={{ textAlign: "center", paddingBottom: "2rem" }}>
                                <div>
                                    <img src={orderAheadImg} alt="..." className={classes.productImage} />
                                </div>
                                <div
                                    className={classes.featureBoxTitle}
                                    style={{
                                        textAlign: "center",
                                        paddingTop: "1.5rem",
                                    }}>
                                    <span
                                        style={{
                                            fontWeight: "500",
                                            fontSize: "1.3rem",
                                        }}>
                                        {" "}
                                        Order Ahead
                                    </span>
                                </div>
                                <div className={classes.productImagesDescription}>
                                    Who has time to wait? Encourage your customers to order ahead & skip the line.
                                    Increase order volume and customer efficiency.
                                </div>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={3} lg={3} style={{ textAlign: "center", paddingBottom: "2rem" }}>
                                <div>
                                    <img src={deliveryImg} alt="..." className={classes.productImage} />
                                </div>
                                <div
                                    className={classes.featureBoxTitle}
                                    style={{
                                        textAlign: "center",
                                        paddingTop: "1.5rem",
                                    }}>
                                    <span
                                        style={{
                                            fontWeight: "500",
                                            fontSize: "1.3rem",
                                        }}>
                                        {" "}
                                        Delivery
                                    </span>
                                </div>
                                <div className={classes.productImagesDescription}>
                                    Manage deliveries through your own delivery team or utilize Doordash, our primary
                                    delivery & logistics partner!
                                </div>
                            </GridItem>
                            <GridItem xs={0} sm={0} md={0} lg={1} style={{ textAlign: "left" }} />
                        </GridContainer>
                    </div>
                </div>
            </div>
        )
    }
}

export default withStyles(productStyle)(ProductImagesSection)



// WEBPACK FOOTER //
// ./src/views/LandingPage/Sections/ProductImagesSection.jsx